import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';
import { NewsletterAudience, NEWSLETTER_AUDIENCES_PATH } from './NewsletterTypes';

// Lists the audiences with their current size, a row opens the audience page
const NewsletterAudienceList: React.FC = () => {
    const { t } = useTranslation();

    // Specify the options of this list
    const query = {
        endpoint: 'get_newsletter_audience_list',
        defaultParams: { 'deleted': false },
        object: 'newsletter_audience'
    };
    const objectName = 'newsletters.audiences.object_name';
    const showSearch = false;
    const showDeleteOrDeactivate = 'flag_deleted';
    const isPaginated = false;

    // Open the audience page for new audiences and for the rows
    const openPageUrl = `${NEWSLETTER_AUDIENCES_PATH.slice(1)}/new`;
    const onRowClick = 'detailPage';
    const detailPageUrl = NEWSLETTER_AUDIENCES_PATH.slice(1);

    // Describes the current size of an audience between brackets
    const describeCount = (audience: NewsletterAudience): string => {
        if (!audience.is_valid || audience.contact_count === null) return t('newsletters.audiences.invalid');
        return t(audience.source === 'users' ? 'newsletters.audiences.user_count' : 'newsletters.audiences.contact_count', { count: audience.contact_count });
    };

    // Specify the single column of this list
    const columns: ListColumnType[] = useMemo(() => [
        {
            width: '1fr', field: 'name', label: 'newsletters.audiences.column_name',
            render: (value: string, row: any) => (
                <span className='newsletter-subject-cell'>
                    <span className='newsletter-subject-text'>{value}</span>
                    <span className={`newsletter-recipient-suffix ${!row.is_valid ? 'newsletter-audience-invalid' : ''}`}>({describeCount(row as NewsletterAudience)})</span>
                </span>
            ),
        },
    ], [t]);

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            openPageUrl={openPageUrl}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
            detailPageUrl={detailPageUrl}
            buttonSize='small'
        />
    );
};

export default NewsletterAudienceList;
